import { useSelector } from 'react-redux';
import { TState } from '../../redux/store';
import { allIcons, NormalIcon } from '../utils/Icon';
import { fetchRowsData } from '../../api/tabsApi';
import { exportToExcel } from '../../helpers';
import { Box, Tooltip } from '@chakra-ui/react';
import Chip from '../common/Chip';
import { chipStyle } from '../layout/Toolbar';

const DownloadComponent = () => {
  const rowSelected = useSelector((state: TState) => state.rowSelected);
  const currentTab = useSelector((state: TState) => state.currentTab);
  const user = useSelector((state: TState) => state.user);

  const downloadData = async () => {
    const promises: any[] = [];

    if (!rowSelected.length) return;

    const rs = [...rowSelected];

    while (rs.length) {
      const rows = rs.splice(0, 2000);
      currentTab?._id && promises.push(fetchRowsData(currentTab?._id, rows));
    }

    const resps = await Promise.all(promises);
    exportToExcel(resps.flat(), `export_${currentTab?.title}`);
  };

  return user.isAdmin ? (
    <Box position='relative' cursor='pointer'>
      <Tooltip label="Téléchargez l'export des lignes sélectionnées">
        <span>
          <NormalIcon
            disabled={!rowSelected.length}
            as={allIcons.HiFolderArrowDown}
            onClick={() => downloadData()}
          />
          {rowSelected.length > 0 && (
            <Chip
              nb={rowSelected.length}
              bgColor='red.500'
              color='white'
              style={chipStyle}
            />
          )}
        </span>
      </Tooltip>
    </Box>
  ) : null;
};

export default DownloadComponent;
